import React from 'react';
import { Box } from '@mui/material';
import { useListPropertyContext } from '../../../../../contexts/ListPropertyContext';
import ReusableTextField from '../../../../../components/ReusableTextField/ReusableTextField';

const PropertyDetailsSection = () => {
  const { formData, updateFormData } = useListPropertyContext();

  const handleTitleChange = (e) => {
    updateFormData('propertyTitle', e.target.value);
  };

  const handleDescriptionChange = (e) => {
    updateFormData('description', e.target.value);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <ReusableTextField
        label="Property Title"
        value={formData.propertyTitle}
        onChange={handleTitleChange}
      />
      <ReusableTextField
        label="Description"
        value={formData.description}
        onChange={handleDescriptionChange}
        multiline
        rows={4}
      />
    </Box>
  );
};

export default PropertyDetailsSection;

